import { useCallback, useEffect, useState } from 'react';

import { searchAlgoliaFetchListingsById } from 'modules/search/algolia/fetch/searchAlgoliaFetchListingsById';
import { SearchAlgoliaRecommendedListing } from 'modules/search/algolia/types/SearchAlgoliaRecommendedListing';
import { identityFilter } from 'utils/functional';
import { setError } from 'zustand-stores/errorStore';

const attributesToFetch = [
  '_geoloc',
  'name',
  'url',
  'city',
  'id',
  'logo',
  'orgName',
  'name',
  'state',
] satisfies Array<keyof SearchAlgoliaRecommendedListing | '_geoloc'>;

type Args = {
  listingIds: string[] | undefined;
};

export function useSearchAlgoliaFetchListings({ listingIds }: Args): {
  jobRecommendations: SearchAlgoliaRecommendedListing[] | undefined;
} {
  const [jobRecommendations, setJobRecommendations] =
    useState<SearchAlgoliaRecommendedListing[]>();

  const load = useCallback(async () => {
    if (!listingIds) return;

    try {
      const jobs =
        await searchAlgoliaFetchListingsById<SearchAlgoliaRecommendedListing>({
          listingIds,
          attributes: attributesToFetch,
        });
      setJobRecommendations(jobs?.filter(identityFilter) || []);
    } catch (e) {
      setError(e as Error);
      setJobRecommendations([]);
    }
  }, [listingIds]);

  useEffect(() => {
    load();
  }, [load]);

  return { jobRecommendations };
}
